import React, { useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SuggestionsList = styled.ul`
  position: absolute;
  z-index: 10;
  width: 100%;
  background: #fff;
  border: 1px solid #ccc;
  max-height: 180px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const SuggestionItem = styled.li`
  padding: 8px 12px;
  cursor: pointer;
  &:hover {
    background: #f0f0f0;
  }
`;


// export const inputStyle = `
//   font-size: 15px;
//   width: 100%;
//   border-radius: 5px;
//   padding: 7px; 
//   color: var(--admincat-color-grey-2);
//   background-color: var(--admincat-color-grey-1);
//   box-sizing: border-box; 
//   height: 40px; 
// `;

// const StyledInput = styled.input`
//   &&& {
//     ${inputStyle}
//     height: 40px;
//     box-sizing: border-box; 
//     width: 100%; 
//     background-color: var(--admincat-color-grey-1);
    
//     /* Ensure text color is consistent and visible in both modes */
//     color: var(--admincat-color-grey-2);
    
//   }
// `;

const StyledInput = styled.input`
  width: 100%;
  padding: 7px;
  border-radius: 5px;
  color: var(--admincat-color-grey-2);
  background-color: var(--admincat-color-grey-1);
  border: 1px solid #ccc;
  font-size: 15px;
  box-sizing: border-box;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
`;

const AutoCompleteInput = ({
  options = [],
  value,
  onChange,
  name,
  placeholder,
  label,
  ...rest
}) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [inputValue, setInputValue] = useState(value || '');

  React.useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const filteredOptions = options.filter(
    (opt) =>
      opt.label &&
      opt.label.toLowerCase().includes(inputValue.toLowerCase())
  );

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setShowSuggestions(true);
    if (onChange) {
      onChange({
        target: {
          name,
          value: e.target.value,
        },
      });
    }
  };

  const handleSuggestionClick = (option) => {
    setInputValue(option.label);
    setShowSuggestions(false);
    if (onChange) {
      onChange({
        target: {
          name,
          value: option.label,
        },
      });
    }
  };

  return (
    <Wrapper>
      {label && <Label>{label}</Label>}
      <StyledInput
        {...rest}
        name={name}
        value={inputValue}
        placeholder={placeholder}
        autoComplete="off"
        onChange={handleInputChange}
        onFocus={() => setShowSuggestions(true)}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 100)}
      />
      {showSuggestions && filteredOptions.length > 0 && (
        <SuggestionsList>
          {filteredOptions.map((option) => (
            <SuggestionItem
              key={option.id || option.label}
              onMouseDown={() => handleSuggestionClick(option)}
            >
              {option.label}
            </SuggestionItem>
          ))}
        </SuggestionsList>
      )}
    </Wrapper>
  );
};

export default AutoCompleteInput;